import { render, staticRenderFns } from "./utente-form.vue?vue&type=template&id=978c8588&scoped=true&lang=html&"
import script from "./utente-form.vue?vue&type=script&lang=js&"
export * from "./utente-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978c8588",
  null
  
)

export default component.exports